import { render, staticRenderFns } from "./perfcons.vue?vue&type=template&id=52d4b5ee&scoped=true&"
import script from "./perfcons.vue?vue&type=script&lang=js&"
export * from "./perfcons.vue?vue&type=script&lang=js&"
import style0 from "./perfcons.vue?vue&type=style&index=0&id=52d4b5ee&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d4b5ee",
  null
  
)

export default component.exports